<template>

  <PageHeader
    title="Entity Management"
    subtitle="Configure entity types, create entities, manage relationships, user assignments, and set up classifiers"
    :breadcrumbs="[{ label: 'Admin Console' }]"
  >
    <template #bottom>
      <Page_Tabs
        class="px-6 pt-4"
        :tabs="tabLabels"
        :initial-tab="activeTabLabel"
        no-border
        @select="handleTabSelect"
      />
    </template>
  </PageHeader>

  <div class="entity-management-container p-4">
    <!-- Tab Content -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200">
      <EntityTypeConfiguration v-if="activeTab === 'configuration'" />
      <EntityCreator v-if="activeTab === 'creator'" />
      <UserEntityAssignments v-if="activeTab === 'user-assignments'" />
      <EntityRelationshipManager v-if="activeTab === 'relationships'" />
      <ClassificationManager v-if="activeTab === 'classification'" />
      <EntityScorecardMetrics v-if="activeTab === 'scorecard-metrics'" />
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle, faCogs, faUsers, faTags, faProjectDiagram, faPlus } from '@fortawesome/free-solid-svg-icons';
import EntityTypeConfiguration from '@/components/Entity/EntityTypeConfiguration.vue';
import UserEntityAssignments from '@/components/Entity/UserEntityAssignments.vue';
import ClassificationManager from '@/components/Entity/ClassificationManager.vue';
import EntityRelationshipManager from '@/components/Entity/EntityRelationshipManager.vue';
import EntityCreator from '@/components/Entity/EntityCreator.vue';
import EntityScorecardMetrics from '@/components/Entity/EntityScorecardMetrics.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';

library.add(faInfoCircle, faCogs, faUsers, faTags, faProjectDiagram, faPlus);

export default {
  name: 'EntityManagementContainer',
  components: {
    FontAwesomeIcon,
    EntityTypeConfiguration,
    UserEntityAssignments,
    ClassificationManager,
    EntityRelationshipManager,
    EntityCreator,
    EntityScorecardMetrics,
    PageHeader,
    Page_Tabs
  },
  data() {
    return {
      activeTab: localStorage.getItem('entity_management_tab') || 'configuration',
      tabs: [
        {
          key: 'configuration',
          label: 'Entity Configuration',
          icon: ['fas', 'cogs'],
          description: 'Define entity types, manage their attributes, and configure display components'
        },
        {
          key: 'creator',
          label: 'Entity Creator',
          icon: ['fas', 'plus'],
          description: 'Manually create new entities with custom attributes and relationships'
        },
        {
          key: 'user-assignments',
          label: 'User Assignments',
          icon: ['fas', 'users'],
          description: 'Assign entity types to users and manage user-entity relationships'
        },
        {
          key: 'relationships',
          label: 'Relationship Manager',
          icon: ['fas', 'project-diagram'],
          description: 'Manage parent-child relationships between entities'
        },
        {
          key: 'classification',
          label: 'Classification Management',
          icon: ['fas', 'tags'],
          description: 'Create and manage entity classifiers using AI-powered InfoTagTypes'
        },
        {
          key: 'scorecard-metrics',
          label: 'Key Metrics Config',
          icon: ['fas', 'cogs'],
          description: 'Configure which key metrics display for specific entities'
        }
      ]
    };
  },
  watch: {
    activeTab(newTab) {
      localStorage.setItem('entity_management_tab', newTab);
    }
  },
  computed: {
    tabLabels() {
      return this.tabs.map(t => t.label);
    },
    activeTabLabel() {
      const tab = this.tabs.find(t => t.key === this.activeTab);
      return tab ? tab.label : this.tabs[0].label;
    }
  },
  methods: {
    handleTabSelect(label) {
      const tab = this.tabs.find(t => t.label === label);
      if (tab) this.activeTab = tab.key;
    }
  }
};
</script>

<style scoped>
/* Component-specific styles if needed */
</style>
